import { render, staticRenderFns } from "./cg-stage-image.vue?vue&type=template&id=6c920f61&scoped=true"
import script from "./cg-stage-image.vue?vue&type=script&lang=js"
export * from "./cg-stage-image.vue?vue&type=script&lang=js"
import style0 from "./cg-stage-image.vue?vue&type=style&index=0&id=6c920f61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c920f61",
  null
  
)

export default component.exports